import moment from 'moment';

export class MerchantLegalEntityListRequest {
    constructor(params) {
        this.pageNumber = params.pageIndex ?? null;
        this.pageSize = params.pageSize ?? null;
        this.entityType = 'MLE';
        this.sort = 'createdOn';

        this.merchantId = params.merchantId ?? null;
        this.name = params.name ?? null;
        this.source = params.source ?? null;

        // Default to true if enterprise_merchant is undefined
        this.enterpriseMerchant =
            params.enterprise_merchant !== undefined
                ? params.enterprise_merchant === 'yes'
                : true;

        if (params.createdOn) {
            const start = moment(params.createdOn.startDate).format('YYYY-MM-DD');
            const end = moment(params.createdOn.endDate).format('YYYY-MM-DD');
            this.createdOn = `btn:${start},${end}`;
        } else {
            this.createdOn = null;
        }
    }
}
